import { useInView } from "react-intersection-observer";
import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Slot } from "../Slot/Slot";
import styles from "./Default.module.scss";
import classNames from "classnames/bind";
import { useMobileHeaderPeep } from "../../hooks/useMobileHeaderPeep";
// import { useStickyHeaderPeep } from "../../hooks/useStickyHeaderPeep";
import useRouteLoading from "../../hooks/useRouteLoading";

const cx = classNames.bind(styles);

export const slotNameMap = {
  BANNER: "banner",
  HEADER: "header",
  TOP: "top",
  ACCESSORY: "accessory",
  MAIN_TOP: "main-top",
  STICKY_BAR: "sticky-bar",
  MAIN: "main",
  FOOTER: "footer",
} as const;

export function Default(props: PageProps) {
  const { ref: stickySentinelRef, inView: stickySentinelInView } = useInView({
    initialInView: true,
  });

  const isRouteLoading = useRouteLoading();
  const hasMobileHeaderPeeped = useMobileHeaderPeep();
  //const hasStickyHeaderPeeped = useStickyHeaderPeep();
  const hasHeaderPeeped = hasMobileHeaderPeeped; //|| hasStickyHeaderPeeped;

  return (
    <div data-layout="Default" className={styles.page}>
      <Slot {...props} name={slotNameMap["HEADER"]} sizes="100vw" />
      <main className={styles.main}>
        <Slot
          {...props}
          name={slotNameMap["BANNER"]}
          sizes="100vw"
          className={styles.banner}
        />
        <Slot
          {...props}
          name={slotNameMap["TOP"]}
          sizes="100vw"
          className={styles.top}
        />
        <div className={styles.columns}>
          <div
            className={cx("accessoryWrapper", {
              "u-loading": isRouteLoading,
              headerPeeped: hasHeaderPeeped,
              isStuck: !stickySentinelInView,
            })}
          >
            <Slot
              {...props}
              name={slotNameMap["ACCESSORY"]}
              className={cx("accessory", {
                headerPeeped: hasHeaderPeeped,
              })}
              sizes="100vw"
            />
          </div>
          <div className={styles.content}>
            <Slot
              {...props}
              name={slotNameMap["MAIN_TOP"]}
              className={cx("mainTop")}
              sizes="100vw"
            />
            <div ref={stickySentinelRef} className={styles.stickySentinel} />
            <Slot
              {...props}
              name={slotNameMap["STICKY_BAR"]}
              className={cx("stickyBar", {
                isStuck: !stickySentinelInView,
                headerPeeped: hasHeaderPeeped,
                "u-loading": isRouteLoading,
              })}
              sizes="100vw"
            />
            <Slot
              {...props}
              id="main-content-slot"
              name={slotNameMap["MAIN"]}
              sizes="100vw"
              className={cx("mainSlot", {
                "u-loading": isRouteLoading,
                headerPeeped: hasHeaderPeeped,
              })}
            />
          </div>
        </div>
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} sizes="100vw" />
    </div>
  );
}
